import './HorizontalScroll.sass';

import React, { forwardRef } from 'react';
import { HorizontalScrollProps } from '$uikit/HorizontalScroll/HorizontalScroll.interface';

export const HorizontalScroll = forwardRef<HTMLDivElement, HorizontalScrollProps>(
  ({ children, onScroll, className = '' }, ref) => {
    return (
      <div className="HorizontalScroll">
        <div
          className={`HorizontalScroll__content ${className}`}
          onScroll={onScroll}
          ref={ref}
        >
          {children}
        </div>
      </div>
    );
  },
);

HorizontalScroll.displayName = 'HorizontalScroll';
